import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import { YUPValidationsParameter } from "./helper";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import {
  addParameterCreationAction,
  getParameterCreationAction,
} from "../../../../redux/actions/TestPackageCreationAction";

export const AddParameterCreationPopup = ({
  isAddParameter,
  setIsAddParamter,
  searchFilterParameter,
  isRowDataTest,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (isAddParameter?.rowData) {
      setData(isAddParameter?.rowData);
    }
  }, [isAddParameter]);

  const handleClose = async () => {
    setIsAddParamter({
      isOpen: false,
      rowData: null,
    });
    await dispatch(
      getParameterCreationAction({
        ...searchFilterParameter,
      })
    );
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {isAddParameter?.rowData === null
            ? "Add Parameter"
            : "Update Parameter"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            testId: isRowDataTest?.productFacilityId,
            testParameterId:
              isAddParameter?.rowData === null
                ? 0
                : isAddParameter?.rowData?.testParameterId,
            isActive:
              isAddParameter?.rowData === null ? true : values?.isActive,
          };
          const resp = dispatch(addParameterCreationAction(temp));
          resp.then((res) => {
            isLoadingAction(true, dispatch);
            if (res?.data?.status === true) {
              getSnackbarSuccess("success", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
              handleClose();
            } else {
              getSnackbarSuccess("error", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
            }
          });
        }}
        validationSchema={YUPValidationsParameter}
      >
        {(props) => {
          const { values, errors, handleChange, setFieldValue, handleSubmit } =
            props;
          return (
            <form
              className="form-admin"
              style={{ overflowX: "hidden" }}
              onSubmit={handleSubmit}
            >
              <div className="modal-body addusermodalbox">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <label className="col-form-label">
                      Parameter Name
                      <MandatoryStar />
                    </label>
                    <input
                      name="testParameterName"
                      type="text"
                      placeholder="Enter Here..."
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.testParameterName}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.testParameterName}
                    </div>
                  </div>
                  {isAddParameter?.rowData !== null && (
                    <div className="col-lg-12 col-md-12">
                      <label className="col-form-label">
                        Status
                        <MandatoryStar />
                      </label>
                      <select
                        className="form-control form-select-admin inputbgavanish"
                        value={
                          values?.isActive === null ? "" : values?.isActive
                        }
                        onChange={(e) =>
                          setFieldValue(
                            "isActive",
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                              ? false
                              : e.target.value === "" && null
                          )
                        }
                      >
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                      </select>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0  mt-4">
                <div></div>
                <div className="d-flex justify-content-end flex-wrap gap-10">
                  <button type="submit" className="savedetails">
                    {isAddParameter?.rowData === null ? "Save" : "Update"}
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};
